import React, { useContext } from "react";
import { Box } from "@mui/material";

import { ViewModeContext } from "../../context/ViewModeContext";

import { Thumbnail } from "../../components/custom/Thumbnail";
import { Listbox } from "../../components/custom/Listbox";

import { nervousSystemVideoData } from "../../utils/videoData";

const NerveousSystemPage = () => {
  const { viewMode } = useContext(ViewModeContext);

  return (
    <Box
      display={viewMode === "thumbnail" ? "grid" : "block"}
      gap={2}
      sx={{
        margin: 0,
        padding: {
          lg: viewMode === "thumbnail" ? 8 : 5,
          md: viewMode === "thumbnail" ? 5 : 2,
          sm: viewMode === "thumbnail" ? 5 : 2,
          xs: viewMode === "thumbnail" ? 2 : 2,
        },
        gridTemplateColumns:
          viewMode === "thumbnail"
            ? {
                xs: "repeat(auto-fill, minmax(280px, 1fr))",
                sm: "repeat(auto-fill, minmax(350px, 1fr))",
              }
            : "none",
      }}
    >
      {nervousSystemVideoData.map((video, index) =>
        viewMode === "thumbnail" ? (
          <Thumbnail key={index} {...video} />
        ) : (
          <Listbox key={index} {...video} />
        )
      )}
    </Box>
  );
};

export default NerveousSystemPage;
